var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCircleOutlineMessages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 34.5,
  stroke: "#B8BABF",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B8BABF",
  d: "M24 22.5c-1.65 0-3 1.35-3 3v18l4.5-4.5H30v4.5c0 1.65 1.35 3 3 3h13.5L51 51V33c0-1.65-1.35-3-3-3h-6v-4.5c0-1.65-1.35-3-3-3zm0 3h15V36H24zM42 33h6v10.5H33V39h6c1.65 0 3-1.35 3-3z"
}))));
export default SvgIconCircleOutlineMessages;